import {
  HttpClient,
  HttpBackend,
  HttpErrorResponse,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { throwError, Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class UserManagementService {
  token: string;

  constructor(
    private http: HttpClient,
    private httpClient: HttpClient,
    handler: HttpBackend
  ) {
    this.httpClient = new HttpClient(handler);
    this.token = localStorage.getItem("currentClient");
  }
  private API = "api/user/";

  handleError(error: HttpErrorResponse) {
    return throwError(error);
  }

  get(payload): Observable<any> {
    return this.http
      .get(this.API + "users", { params: payload })
      .pipe(catchError(this.handleError));
  }

  searchByNamePhoneEmail(params): Observable<any> {
    return this.http
      .get(this.API + "search", { params: params })
      .pipe(catchError(this.handleError));
  }

  create(payload): Observable<any> {
    return this.http
      .post(this.API + "createUser", payload)

      .pipe(catchError(this.handleError));
  }
  update(payload): Observable<any> {
    return this.http
      .post(this.API + "updateUserAccount", payload)

      .pipe(catchError(this.handleError));
  }

  // resetPassword(payload): Observable<any> {
  //   return this.http
  //     .post(this.API + 'resetPassword', payload)

  //     .pipe(catchError(this.handleError));
  // }
  resetPassword(payload): Observable<any> {
    return this.httpClient
      .get("/api/applicant/forget-password/" + payload.email)

      .pipe(catchError(this.handleError));
  }
}
